import React, { useEffect, useState } from "react";

const TypewriterText = ({ text, className }) => {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index < text.length) {
      const timer = setTimeout(() => {
        setDisplayedText(displayedText + text[index]);
        setIndex(index + 1);
      }, 40); // Adjust typing speed here
      return () => clearTimeout(timer);
    }
  }, [displayedText, index, text]);

  return <h2 className={className}>{displayedText}</h2>;
};

export default TypewriterText;
